var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.633 8.213h4.51L18.93 3v4.51c0 .388.315.703.703.703Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.967 27h14.062c1.163 0 2.11-.946 2.11-2.11V10.032h-4.922a2.112 2.112 0 0 1-2.11-2.11V3h-9.14c-1.164 0-2.11.946-2.11 2.11v19.78c0 1.164.946 2.11 2.11 2.11Zm4.218-12.703h7.032a.703.703 0 1 1 0 1.406h-7.032a.703.703 0 1 1 0-1.406Zm0 2.812h7.032a.703.703 0 1 1 0 1.407h-7.032a.703.703 0 1 1 0-1.407Zm0 2.813h7.032a.703.703 0 1 1 0 1.406h-7.032a.703.703 0 1 1 0-1.406Zm-2.812-5.625a.703.703 0 1 1 0 1.406.703.703 0 0 1 0-1.406Zm0 2.812a.703.703 0 1 1 0 1.407.703.703 0 0 1 0-1.407Zm0 2.813a.703.703 0 1 1 0 1.406.703.703 0 0 1 0-1.406Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.79586d14.svg";
export { ForwardRef as ReactComponent };